import {JSX, ReactNode} from "react";

interface HeroLogoProps {
    children?: ReactNode;
}

export function HeroLogo({children}: HeroLogoProps): JSX.Element {
    return <>{children}</>;
}
